<template>
    <Head :title="investor.data.name">
        <component :is="`script`" type="application/ld+json">
            {{ schema }}
        </component>
    </Head>

    <AppLayout :title="investor.data.name">

        <div class="mx-auto flex w-full  items-start  py-4">
            <div class="hidden lg:block w-[252px]"/>
            <div class="flex-1 lg:px-8">
                <GlobalSearch/>
            </div>
            <div class="hidden lg:block w-[252px]"/>
        </div>


        <div class="flex flex-wrap items-start">
            <div class="lg:w-2/5 lg:pr-6 lg:sticky lg:top-0 pt-8">

                <div class="justify-between items-center gap-4 flex w-full border-b pb-4">
                    <div class="justify-start items-center gap-4 flex">
                        <div class="w-[72px] h-[72px] relative rounded-full">
                            <img
                                :src="investor.data.profile_photo_url"
                                class="w-[72px] object-contain h-[72px] left-0 top-0 absolute  rounded-[100px]">
                        </div>
                        <div class="justify-start items-center gap-1.5 flex">
                            <div class="text-zinc-800 text-2xl font-bold leading-loose">{{ investor.data.name }}</div>
                            <svg
                                v-if="investor.data.has_owner" fill="none" height="32" viewBox="0 0 32 32" width="32"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M28 16C27.977 15.175 27.7254 14.3716 27.272 13.6807C26.8199 12.9911 26.1839 12.4393 25.4355 12.0894C25.7203 11.3142 25.7803 10.4751 25.6143 9.66667C25.447 8.85696 25.0562 8.11111 24.4879 7.51213C23.8876 6.94381 23.143 6.55428 22.3333 6.3857C21.5249 6.21967 20.6858 6.27969 19.9106 6.5645C19.5619 5.81481 19.0115 5.17752 18.3206 4.72541C17.6296 4.27331 16.8263 4.02043 16 4C15.175 4.02171 14.3742 4.27203 13.6845 4.72541C12.9949 5.1788 12.447 5.81609 12.1009 6.5645C11.3244 6.27969 10.4828 6.21711 9.67178 6.3857C8.86079 6.55172 8.11367 6.94253 7.51341 7.51213C6.94508 8.11239 6.55683 8.85951 6.39208 9.66794C6.22605 10.4764 6.28991 11.3155 6.57599 12.0894C5.82631 12.4393 5.18774 12.9898 4.73308 13.6794C4.27842 14.3691 4.02427 15.1737 4 16C4.02554 16.8263 4.27842 17.6296 4.73308 18.3206C5.18774 19.0102 5.82631 19.5619 6.57599 19.9106C6.28991 20.6845 6.22605 21.5236 6.39208 22.3321C6.55811 23.1418 6.94508 23.8876 7.51213 24.4879C8.11239 25.0536 8.85824 25.4419 9.66667 25.6092C10.4751 25.7778 11.3142 25.7165 12.0894 25.4355C12.4393 26.1839 12.9898 26.8199 13.6807 27.2733C14.3704 27.7254 15.175 27.977 16 28C16.8263 27.9796 17.6296 27.728 18.3206 27.2759C19.0115 26.8238 19.5619 26.1852 19.9106 25.4368C20.682 25.742 21.5275 25.8148 22.341 25.6462C23.1533 25.4776 23.8991 25.0753 24.4866 24.4879C25.0741 23.9004 25.4776 23.1545 25.6462 22.341C25.8148 21.5275 25.742 20.682 25.4355 19.9106C26.1839 19.5607 26.8199 19.0102 27.2733 18.3193C27.7254 17.6296 27.977 16.825 28 16ZM14.2912 20.917L9.91188 16.539L11.5632 14.8761L14.2094 17.5224L19.8289 11.3997L21.5492 12.9911L14.2912 20.917Z"
                                    fill="#333333"/>
                            </svg>

                        </div>
                    </div>
                    <div class="px-3 py-2 bg-neutral-100 rounded-full justify-center items-center gap-1.5 flex">
                        <div class="text-center text-zinc-800 text-xl font-bold leading-normal">{{
                            investor.data.star_rating}}
                        </div>

                        <svg fill="none" height="19" viewBox="0 0 20 19" width="20" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 0L12.8214 6.11672L19.5106 6.90983L14.5651 11.4833L15.8779 18.0902L10 14.8L4.12215 18.0902L5.43493 11.4833L0.489435 6.90983L7.17863 6.11672L10 0Z"
                                fill="#333333"/>
                        </svg>

                    </div>
                </div>


                <div class="pt-4">
                    <h3 v-if="!hideBio" class="font-medium mb-2">About {{ investor.data.name }}</h3>
                    <p v-if="!hideBio" class="text-sm pb-4 text-gray-400  font-normal leading-tight">
                        {{ investor.data.bio }}
                    </p>


                    <div class="flex items-center justify-between pb-6">
                        <div
                            class="flex items-center  space-x-4 text-zinc-800 text-sm font-medium leading-tight"
                        >

                            <div v-if=" investor.data.location" class="flex items-center">
                                <MapPinIcon
                                    class="h-4 w-4 text-gray-400 mr-1 flex-shrink-0"
                                />

                                <div>
                                    {{ investor.data.location }}
                                </div>
                            </div>

                            <a
                                v-if="investor.data.website_url"
                                :href="investor.data.website_url"
                                class="flex items-center  group"
                                target="_blank"
                            >
                                <LinkIcon
                                    class="h-4 w-4 text-gray-400 group-hover:text-gray-700 flex-shrink-0  mr-1"
                                />


                                <div class="group-hover:text-gray-700">
                                    {{ investor.data.website_url_label }}
                                </div>
                            </a>
                        </div>


                        <div class="flex space-x-4 items-center">

                            <a
                                v-if="investor.data.twitter_url"
                                :href="investor.data.twitter_url"
                                target="_blank"
                            >
                                <TwitterIcon
                                    class="h-4 w-4 text-gray-400 flex-shrink-0  hover:text-gray-700 -mb-1"
                                />
                            </a>

                            <a
                                v-if="investor.data.linkedin_url"
                                :href="investor.data.linkedin_url"
                                target="_blank"
                            >
                                <LinkedinIcon
                                    class="h-4 w-4 flex-shrink-0 text-gray-400 hover:text-gray-700"
                                />
                            </a>
                        </div>

                    </div>


                    <div class="mb-[16px]">
                        <Accordion class="w-full">
                            <template #heading>
                                <svg
                                    class="mr-2" fill="none" height="15" viewBox="0 0 16 15" width="16"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8 0L10.2571 4.89337L15.6085 5.52786L11.6521 9.18663L12.7023 14.4721L8 11.84L3.29772 14.4721L4.34794 9.18663L0.391548 5.52786L5.7429 4.89337L8 0Z"
                                        fill="#828F9B"/>
                                </svg>

                                <div>
                                    Average Ratings
                                </div>
                            </template>


                            <template #content>
                                <div class="grid  grid-cols-1 pt-[16px]">
                                    <div
                                        v-for="(rating, index) in investor.data.average_star_ratings" :key="index"
                                        class="h-6 justify-start  gap-2 flex items-center">
                                        <div class="w-6 text-center text-zinc-800 text-sm font-medium leading-normal">{{
                                            rating.score}}
                                        </div>
                                        <readonly-rating :rating="rating.score" size="small"/>
                                        <div class="text-center text-gray-400 text-sm font-medium leading-normal">{{
                                            rating.label }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Accordion>

                    </div>


                    <div
                        v-if="investor.data.badges && investor.data.badges.indexOf('diversity') !== -1"
                        class="py-6 border-t">

                        <div class="flex items-center  mb-4">
                            <div class="pr-4"><img alt="Diversity" class="w-16" src="/img/badges/diversity.svg">
                            </div>
                            <div class="text-gray-400 text-xs font-normal leading-[18px] flex-1 pt-1">{{
                                investor.data.name }} has been accredited
                                the
                                Diversity VC Standard. The Diversity VC Standard is an assessment and
                                certification process that sets a benchmark for best practice on Diversity and Inclusion
                                (D&amp;I) in VC and sends a signal that a fund follows best D&amp;I practices to the
                                rest of the ecosystem.
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div class="lg:w-3/5 lg:pl-6 lg:pt-8">


                <div class="flex items-center justify-between mb-5">


                    <h2 class="text-gray-400 text-base font-medium leading-normal ">{{
                        investor.data.reviews.length
                        }} Reviews
                        for {{ investor.data.name }}</h2>


                    <Link
                        :href="route('reviews.create', {investor: investor.data.slug})"
                        class=" h-10 px-6 py-3 bg-zinc-800 rounded-[100px] justify-center items-center gap-2 inline-flex">
                        <div class="text-white text-sm font-medium leading-none">Write a Review</div>
                    </Link>

                </div>


                <div class="space-y-8">
                    <Review
                        v-for="(review, index) in investor.data.reviews" :key="index" :can-reply="permissions.reply"
                        :review="review"/>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
<script>
import UnifiedLayoutTopbar from '@/Layouts/Legacy/UnifiedLayoutTopbar.vue';
import HeadingOne from '@/Components/Legacy/HeadingOne.vue';
import {Link} from '@inertiajs/vue3';
import ReadonlyRating from '@/Components/Legacy/ReadonlyRating.vue';
import TwitterIcon from '@/Components/Legacy/TwitterIcon.vue';
import LinkedinIcon from '@/Components/Legacy/LinkedinIcon.vue';
import {MapPinIcon, LinkIcon} from '@heroicons/vue/24/outline/esm/index.js';
import {CheckBadgeIcon} from '@heroicons/vue/24/solid/esm/index.js';
import Review from '@/Components/Legacy/2023/Review.vue';
import {Head} from '@inertiajs/vue3';

import pkg from 'floating-vue';
import AppLayout from '@/Layouts/Legacy/2023/AppLayout.vue';
import GlobalSearch from '@/Components/Legacy/2023/GlobalSearch.vue';
import Accordion from '@/Components/Legacy/2023/Accordion.vue';

const {VTooltip} = pkg;

export default {
    components: {
        Accordion,
        GlobalSearch,
        AppLayout,
        Head,
        Review,
        CheckBadgeIcon,
        ReadonlyRating,
        HeadingOne,
        UnifiedLayoutTopbar,
        Link,
        TwitterIcon,
        LinkedinIcon,
        MapPinIcon,
        LinkIcon,
    },

    directives: {
        'v-tooltip': VTooltip
    },

    props: {
        schema: {
            type: String,
            required: true,
        },
        investor: {
            type: Object,
            required: true,
        },

        permissions: {
            type: Object,
            required: true,
            default: () => {
            },
        }
    },
    computed: {
        hideBio() {
            // Return true if this.investor.data.bio is less than 5 characters or begins with the string "This is the profile for"
            return !this.investor.data.bio || this.investor.data.bio.length < 5 || this.investor.data.bio.startsWith('This is the profile for');
        }
    }
};
</script>
